var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7539 0.581065L11.4033 7.93172L4.0526 0.581065C3.8772 0.405669 3.66898 0.266538 3.43981 0.171614C3.21065 0.07669 2.96503 0.027832 2.71698 0.027832C2.46893 0.027832 2.22331 0.07669 1.99415 0.171614C1.76498 0.266538 1.55675 0.405669 1.38136 0.581065C1.20596 0.756461 1.06683 0.964687 0.971906 1.19385C0.876982 1.42302 0.828125 1.66864 0.828125 1.91669C0.828125 2.16473 0.876982 2.41035 0.971906 2.63952C1.06683 2.86868 1.20596 3.07691 1.38136 3.25231L10.0771 11.9481C10.816 12.6869 12.0095 12.6869 12.7483 11.9481L21.4441 3.25231C21.6197 3.07704 21.7591 2.86886 21.8541 2.63967C21.9492 2.41049 21.9981 2.16481 21.9981 1.91669C21.9981 1.66857 21.9492 1.42288 21.8541 1.1937C21.7591 0.964516 21.6197 0.756332 21.4441 0.581065C20.7052 -0.138844 19.4928 -0.157789 18.7539 0.581065Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandArrowDown);
export default __webpack_public_path__ + "static/media/expand_arrow_down.ea7d5ddda51289b8614b38017b518fb8.svg";
export { ForwardRef as ReactComponent };